<template>
  <div>
    <div id="nav">
      <router-link to="/">home</router-link> |
      <router-link to="/about">about</router-link>
    </div>
    <StartElement></StartElement>
  </div>
</template>

<script setup>
// @ is an alias to /src
import StartElement from '@/components/StartElement.vue';

defineOptions({
  name: 'HomePage'
});
</script>
